var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCdp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2584",
    "data-name": "Rectangle 2584",
    width: 24,
    height: 24,
    transform: "translate(1929.73 1430.042)",
    fill: "#003fb9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_cdp",
    transform: "translate(-1929.73 -1430.042)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5206",
    "data-name": "Group 5206",
    transform: "translate(1929.23 1431.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_213",
    "data-name": "Union 213",
    d: "M19.4,17.1c-.247,0-.857,0-.9,0,.021,0,.629,0,.887,0a1.324,1.324,0,0,1-.887-1c.039.258-.261,1,0,1a1.131,1.131,0,0,1-1-1c-.022-.142.2-.077.447-.014.2.053.416.106.519.044-.009,0-.011-.014-.008-.031s-.006-.013,0-.022l0,0c.006-.015.015-.024.022-.014l0,0c-.08-.419-.406-.9.007-.957,1.766-.265,3-1.2,3-3,0-2.021-.978-4-3-4H17.49a.977.977,0,0,1-.989-1,9.065,9.065,0,0,0-.367-2.949c.133.322.245.654.367.948.271.657,1,1.29,1,2a6.607,6.607,0,0,0-2-4,2.821,2.821,0,0,1,.632,1.052A3.193,3.193,0,0,0,15.5,3.1c-.951-.95-2.6-1-3.948-1H11.5c-2.687,0-4,2.313-4,5a.978.978,0,0,1-.989,1H5.5c-2.021,0-3,1.979-3,4,0,1.8,1.234,2.736,3,3,.413.062.087.539.007.957l0,0c.008-.01.016,0,.022.014l0,0c.009.009.013.018,0,.022s0,.03-.007.031c.1.062.317.01.518-.044.244-.064.469-.129.448.014a1.133,1.133,0,0,1-1,1c.26,0-.039-.742,0-1a1.325,1.325,0,0,1-.888,1c.258,0,.866,0,.888,0-.042,0-.652,0-.9,0a.425.425,0,0,1-.1,0c-2.77-.415-5-2.188-5-5a6.436,6.436,0,0,1,2-4,6.932,6.932,0,0,1,2.311-1.54A4.557,4.557,0,0,1,5.5,6.1c.383-3.332,2.568-6,6-6h1a5.657,5.657,0,0,1,5.426,3.828A5.936,5.936,0,0,0,12.5.1h-1a7.189,7.189,0,0,1,6.846,5.174,8.92,8.92,0,0,0-.42-1.346A7.762,7.762,0,0,1,18.5,6.1a4.556,4.556,0,0,1,1.692.461A6.932,6.932,0,0,1,22.5,8.1c1,1.066,1,2.542,1,4,0,2.813-1.229,4.585-4,5a.41.41,0,0,1-.061,0Zm-.9-1Zm4-4Zm-21,0Zm-1,0Zm17-5Zm-11,0Zm0-.035A6.326,6.326,0,0,1,8.5,3.1l.132-.135A4.936,4.936,0,0,0,6.5,7.062Z",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_211",
    "data-name": "Union 211",
    d: "M8.328,10.207a2.074,2.074,0,0,0-.367-.06h-7a2.061,2.061,0,0,0-.367.06,2.233,2.233,0,0,1-.437.07.272.272,0,0,1-.141-.029.108.108,0,0,1-.054-.1v-5a1.7,1.7,0,0,1,1-1v-1a2.7,2.7,0,0,1,3-3c1.932,0,4,1.038,4,3v1a1.7,1.7,0,0,1,1,1v5c0,.088-.064.13-.2.13A2.223,2.223,0,0,1,8.328,10.207ZM3.962,8.146a2.209,2.209,0,0,1,.365.061,2.241,2.241,0,0,0,.438.07c.131,0,.2-.042.2-.13v-1a1.7,1.7,0,0,0-1-1,.112.112,0,0,0-.091.04c-.076.1-.023.346.031.589a2.076,2.076,0,0,1,.06.372v1Zm-.13.067a.07.07,0,0,0,.065.065c.014,0,.064-.009.064-.13h0C3.845,8.147,3.832,8.193,3.832,8.213ZM6.961,4.146v-1c0-1.377-1.645-2-3-2a1.743,1.743,0,0,0-2,2v1Z",
    transform: "translate(7.54 9.95)",
    fill: "#003fb9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCdp);
export default __webpack_public_path__ + "static/media/ic_cdp.a9b32ac0c6266760af2cd74fb808c11f.svg";
export { ForwardRef as ReactComponent };